import React from "react";
import { Panel } from "./FrequencyChart";
import { Ball } from "./Ball";
import { deletePick, GAME_THEME } from "../lib/api";
import { Trash2, Star } from "lucide-react";
import { toast } from "sonner";

export const SavedPicks = ({ picks, game, onChange }) => {
  const t = GAME_THEME[game];
  const remove = async (id) => {
    await deletePick(id);
    toast.success("Removed");
    onChange?.();
  };
  return (
    <Panel title="Saved Picks" testid="saved-picks"
      right={<span className="text-xs font-mono text-zinc-500">{picks.length}</span>}>
      {!picks.length ? (
        <div className="flex flex-col items-center justify-center py-8 text-zinc-600">
          <Star size={22} className="mb-2" />
          <p className="text-sm">No saved picks yet. Generate some AI picks and bookmark your favorites.</p>
        </div>
      ) : (
        <div className="space-y-2.5">
          {picks.map((p) => (
            <div key={p.id} data-testid={`saved-pick-${p.id}`}
              className="flex items-center justify-between gap-3 rounded-xl bg-zinc-950/50 border border-zinc-800 px-3 py-2.5">
              <div className="flex flex-wrap items-center gap-1.5">
                {p.numbers.map((n) => <Ball key={n} n={n} size="sm" />)}
                <span className="text-zinc-600 text-xs">+</span>
                <Ball n={p.special} special color={t.color} size="sm" />
                {p.strategy && (
                  <span className="ml-2 text-[10px] uppercase tracking-wider text-purple-300/80">{p.strategy}</span>
                )}
              </div>
              <button onClick={() => remove(p.id)} data-testid={`delete-pick-${p.id}`}
                className="text-zinc-600 hover:text-red-400 transition-colors duration-200 shrink-0">
                <Trash2 size={15} />
              </button>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
